function toggleAccordion(id, initialBoot = false) {
  let elem = document.getElementById(id);
  if (elem) {
    let opened = elem.classList.contains('c-faq_accordion__tab--opened');
    document.querySelectorAll('.c-faq_accordion__tab').forEach((e) => {
      e.classList.remove('c-faq_accordion__tab--opened');
    });
    document
      .querySelectorAll('.c-faq_accordion__tab_description')
      .forEach((e) => (e.style.maxHeight = null));

    if (opened) {
      elem.classList.remove('c-faq_accordion__tab--opened');
    } else {
      elem.classList.add('c-faq_accordion__tab--opened');
    }
    let text = document.getElementById(id + '_text');
    if (opened) {
      text.style.maxHeight = null;
    } else {
      setTimeout(function () {
        text.style.maxHeight = text.scrollHeight + 'px';
      }, 400);
    }
    if (!initialBoot) {
      setTimeout(function () {
        const headerHeight = document.querySelector('#header').offsetHeight;
        let y = elem.getBoundingClientRect().top + window.scrollY - 15;
        if (window.innerWidth >= 991) {
          y -= headerHeight;
        }
        window.scroll({
          top: y,
          behavior: 'smooth',
        });
      }, 300);
    }
  }
}

toggleAccordion('faq_accordion_1', true);
